import React, { useEffect, useState, useMemo, useRef } from "react";
import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import { useForm } from "react-hook-form";
import $, { parseJSON } from 'jquery';
import UsNumberValidate from '../../utility/usNumberValidate';
import Services from "../../services/services";
import Pagination from "../../utility/Pagination/Pagination";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import { components } from "react-select";
import { default as ReactSelect } from "react-select";

// --- GA4 TRACKING HELPER ---
const trackGaEvent = (eventName, params) => {
    if (window.gtag) {
        window.gtag('event', eventName, {
            ...params,
            page_type: 'resume_search' 
        });
    }
};

const trackGaEventV2 = (eventName, params) => {
    if (window.gtag) {
        window.gtag('event', eventName, params);
    }
};

// --- CUSTOM SELECT COMPONENTS (For Filter Dropdowns) ---
const MAX_VISIBLE = 1;
const MAX_LABEL_LENGTH = 15;

const CustomOption = (props) => {
    return (
        <components.Option {...props}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                    style={{ marginRight: 8, flexShrink: 0 }}

                    tabIndex={-1}
                    // ADD THIS: Stops the checkbox from breaking the "click outside" detection
                    onMouseDown={(e) => e.preventDefault()}
                />
                <span
                    title={props.label}
                    style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                    {props.label}
                </span>
            </div>
        </components.Option>
    );
};

const CustomValueContainer = ({ children, ...props }) => {
    const selected = props.getValue();
    const visible = selected.slice(0, MAX_VISIBLE);
    const hiddenCount = selected.length - MAX_VISIBLE;

    return (
        <components.ValueContainer {...props}>
            <div style={{ display: "flex", alignItems: "center", flexWrap: "nowrap" }}>
                {visible.map(option => (
                    <span
                        key={option.value}
                        style={{
                            display: "inline-block",
                            background: "#eee",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: 13,
                            maxWidth: 120,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            verticalAlign: "middle",
                        }}
                        title={option.label}
                    >
                        {option.label.length > MAX_LABEL_LENGTH
                            ? option.label.slice(0, MAX_LABEL_LENGTH) + "..."
                            : option.label}
                    </span>
                ))}
                {hiddenCount > 0 && (
                    <span
                        style={{
                            display: "inline-block",
                            background: "#d7eaff",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: 13,
                            color: "#2266aa",
                            fontWeight: 600,
                            verticalAlign: "middle",
                            marginLeft: 4,
                        }}
                        title={`${hiddenCount} more`}
                    >
                        +{hiddenCount}
                    </span>
                )}
                {selected.length === 0 && (
                    <span style={{ color: "#888" }}>{props.selectProps.placeholder || "Select..."}</span>
                )}
            </div>
            {children[1]}
        </components.ValueContainer>
    );
};
// --------------------------------------------------------

const PersonalProfilesAI = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const industryRef = useRef(null);
    const jobTypeRef = useRef(null);
    const educationRef = useRef(null);

     const isReturningFromView = queryParams.get('return') === 'true';

    // Core Classic States
    const [categories, setCategory] = useState([]);
    const [profileList, setProfileList] = useState([]);
    const [profileList_m, setProfileList_m] = useState([]);
    const [educationsList, setEducations] = useState([]);
    const [jobTypes, setJobType] = useState([]);
    const [categoriesSelected, setCategoriesSelected] = useState([]);
    const [profileListFull, setProfileListFull] = useState([]);

    const [isSearched, setIsSearched] = useState(false);
    const [aiIsSearched, setAiIsSearched] = useState(false);

    // Pagination Classic
    const ITEMS_PER_PAGE = 20;
    const [totalItems, setTotalItems] = useState(0);
    const [totalpages, settotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems_m, setTotalItems_m] = useState(0);
    const [totalpages_m, settotalPages_m] = useState();
    const [currentPage_m, setCurrentPage_m] = useState(1);

    // ReactSelect Option States
    const [mulcategories_d, setMulCategory_d] = useState([]);
    const [muljobTypes, setMulJobTypes] = useState([]);
    const [muleducation, setMulEducationTypes] = useState([]);

    // ReactSelect Value States (Desktop & Mobile)
    const [optionCatSelected_d, setoptionCatSelectedd] = useState([]);
    const [optionSelected_d, setoptionSelectedd] = useState([]);
    const [optionEduSelected_d, setoptionEduSelectedd] = useState([]);

    const [optionCatSelected_m, setoptionCatSelectedm] = useState([]);
    const [optionSelected_m, setoptionSelectedm] = useState([]);
    const [optionEduSelected_m, setoptionEduSelectedm] = useState([]);

    const [openDropdown, setOpenDropdown] = useState(null);

    // AI States

    const [searchMode, setSearchMode] = useState("CLASSIC");
    const [aiQuery, setAiQuery] = useState("");
    const [aiQuery_m, setAiQuery_m] = useState("");
    const [aiResults, setAiResults] = useState([]);
    const [aiLoading, setAiLoading] = useState(false);
    const [aiError, setAiError] = useState("");
    const [aiCurrentPage, setAiCurrentPage] = useState(1);
    const [aiTotalItems, setAiTotalItems] = useState(0);
    const [aiDebugData, setAiDebugData] = useState(null);

    const companyId = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
    var pppagenum = queryParams.get('pageid');
    var FileSaver = require('file-saver');

    var session_pageobj = '';
    var webfilters = 1;
    var mobfilters = 1;

    function strCatArr(arr) {
        if (Array.isArray(arr)) {
            arr = arr.join(", ");
            return arr;
        } else {
            return "";
        }
    }

    const cardsloop = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isInsideIndustry = industryRef.current && industryRef.current.contains(event.target);
            const isInsideJobType = jobTypeRef.current && jobTypeRef.current.contains(event.target);
            const isInsideEducation = educationRef.current && educationRef.current.contains(event.target);

            // If the click is outside all three, close whichever is open
            if (!isInsideIndustry && !isInsideJobType && !isInsideEducation) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
/*
    useEffect(() => {
        const savedAIStateStr = sessionStorage.getItem('ai_profile_search_state');
        if (savedAIStateStr) {
            try {
                const savedAIState = JSON.parse(savedAIStateStr);
                if (savedAIState.searchMode) setSearchMode(savedAIState.searchMode);
                if (savedAIState.aiQuery) {
                    setAiQuery(savedAIState.aiQuery);
                    setAiQuery_m(savedAIState.aiQuery);
                }
                if (savedAIState.aiResults) setAiResults(savedAIState.aiResults);
                if (savedAIState.aiCurrentPage) setAiCurrentPage(savedAIState.aiCurrentPage);
                if (savedAIState.aiTotalItems) setAiTotalItems(savedAIState.aiTotalItems);
                if (savedAIState.aiDebugData) setAiDebugData(savedAIState.aiDebugData);
            } catch (e) {
                console.error("Failed to parse saved AI state", e);
            }
        }
    }, []);
    */

     useEffect(() => {
        if (isReturningFromView) {
            const savedAIStateStr = sessionStorage.getItem('ai_profile_search_state');
            if (savedAIStateStr) {
                try {
                    const savedAIState = JSON.parse(savedAIStateStr);
                    if (savedAIState.searchMode) setSearchMode(savedAIState.searchMode);
                    if (savedAIState.aiQuery) {
                        setAiQuery(savedAIState.aiQuery);
                        setAiQuery_m(savedAIState.aiQuery);
                    }
                    if (savedAIState.aiResults) setAiResults(savedAIState.aiResults);
                    if (savedAIState.aiCurrentPage) setAiCurrentPage(savedAIState.aiCurrentPage);
                    if (savedAIState.aiTotalItems) setAiTotalItems(savedAIState.aiTotalItems);
                    if (savedAIState.aiDebugData) setAiDebugData(savedAIState.aiDebugData);
                } catch (e) {
                    console.error("Failed to parse saved AI state", e);
                }
            }
        } else {
            sessionStorage.removeItem('ai_profile_search_state');
            setSearchMode("CLASSIC");
            setAiQuery("");
            setAiQuery_m("");
            setAiResults([]);
            setAiTotalItems(0);
        }
    }, [isReturningFromView]);


    const handleTabChange = (mode) => {
        setSearchMode(mode);
        const existingStateStr = sessionStorage.getItem('ai_profile_search_state');
        let existingState = existingStateStr ? JSON.parse(existingStateStr) : {};
        existingState.searchMode = mode;
        sessionStorage.setItem('ai_profile_search_state', JSON.stringify(existingState));

         // --- GA4 TRACKING ADDED ---
        trackGaEvent('search_mode_change', {
            search_type: mode === "AI" ? "ai_powered" : "classic"
        });
    };

    // Global listener to close dropdowns on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.custom-select-wrapper')) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        $('.doublecards').show();
        if (companyId == null || companyId == "null") {
            navigate('/Home');
        }


         if (!isReturningFromView) {
            sessionStorage.removeItem('pagejsonObject');
            localStorage.removeItem('pagejsonObject');
            sessionStorage.removeItem('master_industry');
            localStorage.removeItem('master_industry');
            sessionStorage.removeItem('master_jobtype');
            localStorage.removeItem('master_jobtype');
            sessionStorage.removeItem('company_profile');
            localStorage.removeItem('company_profile');
            sessionStorage.removeItem('master_educationsprof');
            localStorage.removeItem('master_educationsprof');

            session_pageobj = {
                'search_text': '', 'resumeage': '', 'industry': '', 'jobtype': '', 'educationLevel': '',
                'search_text_m': '', 'resumeage_m': '', 'industry_m': '', 'jobtype_m': '', 'educationLevel_m': ''
            };

            $('#phone').usPhoneFormat();
            $(".searchKeyInput").val('');
            $(".searchKeyInput_m").val('');
            $('input[name="archived_resumes"]').prop("checked", false);
            $('input[name="archived_resumes_m"]').prop("checked", false);

            getServiceProfileInfo();
            getServiceIndustryData();
            getServiceJobType();
            getServiceEdicationInfo();

            filterContent(ITEMS_PER_PAGE, '1', '0', '0');
            filterContent_m(ITEMS_PER_PAGE, '1', '0', '0');

            return; // EXIT EARLY
        }


        var recreateobj = '';
        var keys = sessionStorage.getItem('pagejsonObject') || localStorage.getItem("pagejsonObject");
        if (keys == null || keys == undefined) {
            navigate('/Home');
        } else {
            var keys_parsed = JSON.parse(keys);
            var pageobject = Object.keys(keys_parsed);
            if (pageobject.length > 0) {
                var firstKey = pageobject[0];
                if (firstKey == 'personal_Profiles') {
                    var pageobj = keys_parsed[firstKey];
                    session_pageobj = keys_parsed[firstKey];
                    var dev_poff = pageobj['pagination_val'];
                    var dev_poff_m = pageobj['pagination_val_m'];
                    if (dev_poff == '') {
                        if (dev_poff_m == '') {
                            pppagenum = '1';
                        } else {
                            pppagenum = dev_poff_m;
                        }
                    } else {
                        pppagenum = dev_poff;
                    }
                } else {
                    pppagenum = '1';
                    recreateobj = 1;
                    sessionStorage.removeItem('master_industry');
                    sessionStorage.removeItem('master_jobtype');
                    sessionStorage.removeItem('company_profile');
                    localStorage.removeItem('master_industry');
                    localStorage.removeItem('master_jobtype');
                    localStorage.removeItem('company_profile');
                }
            } else {
                pppagenum = '1';
                recreateobj = 1;
                sessionStorage.removeItem('master_industry');
                sessionStorage.removeItem('master_jobtype');
                sessionStorage.removeItem('company_profile');
                localStorage.removeItem('master_industry');
                localStorage.removeItem('master_jobtype');
                localStorage.removeItem('company_profile');
            }
        }

        if (pppagenum == null || pppagenum == '') {
            var web_searchtxt = session_pageobj['search_text'];
            var web_resumeage = session_pageobj['resumeage'];
            var web_industry = session_pageobj['industry'];
            var web_jobtype = session_pageobj['jobtype'];
            var web_education = session_pageobj['educationLevel'];
            if (web_searchtxt == '' && web_resumeage == '' && web_industry == '' && web_jobtype == '' && web_education == '') {
                var webfilters = 0;
            }

            var mob_searchtxt = session_pageobj['search_text_m'];
            var mob_resumeage = session_pageobj['resumeage_m'];
            var mob_industry = session_pageobj['industry_m'];
            var mob_jobtype = session_pageobj['jobtype_m'];
            var mob_education = session_pageobj['educationLevel_m'];
            if (mob_searchtxt == '' && mob_resumeage == '' && mob_industry == '' && mob_jobtype == '' && mob_education == '') {
                var mobfilters = 0;
            }

            if (webfilters == 0 && mobfilters == 0) {
                var jsonData = {
                    "personal_Profiles": {
                        "industry": '', "resumeage": '', "jobtype": '', "search_text": "", "pagination_val": '', "educationLevel": '',
                        "industry_m": '', "resumeage_m": '', "jobtype_m": '', "search_text_m": "", "pagination_val_m": '', "educationLevel_m": ''
                    }
                };
                var jsondataformatted = JSON.stringify(jsonData);
                sessionStorage.setItem('pagejsonObject', jsondataformatted);
                localStorage.setItem('pagejsonObject', jsondataformatted);
            }
        }

        $('#phone').usPhoneFormat();

        var companyprofileInfo = sessionStorage.getItem('company_profile') || localStorage.getItem("company_profile");
        if (companyprofileInfo == null || companyprofileInfo == '') {
            getServiceProfileInfo();
        } else {
            getLocalProfileInfo();
        }

        var ind_master = sessionStorage.getItem('master_industry') || localStorage.getItem("master_industry");
        if (ind_master == null || ind_master == '') {
            getServiceIndustryData();
        } else {
            getLocalIndustryData();
        }

        var jobtype_master = sessionStorage.getItem('master_jobtype') || localStorage.getItem("master_jobtype");
        if (jobtype_master == null || jobtype_master == '') {
            getServiceJobType();
        } else {
            getLocalJobType();
        }

        var education_master = sessionStorage.getItem('master_educationsprof') || localStorage.getItem("master_educationsprof");
        if (education_master == null || education_master == '') {
            getServiceEdicationInfo();
        } else {
            getLocalEdicationInfo();
        }

        var t_pp_search_text = session_pageobj['search_text'];
        $(".searchKeyInput").val(t_pp_search_text);

        var t_pp_search_text_m = session_pageobj['search_text_m'];
        $(".searchKeyInput_m").val(t_pp_search_text_m);

        var t_pp_resumeage = session_pageobj['resumeage'];
        if (t_pp_resumeage == 1) {
            $('input[name="archived_resumes"]').prop("checked", true);
        }

        var t_pp_resumeage_m = session_pageobj['resumeage_m'];
        if (t_pp_resumeage_m == 1) {
            $('input[name="archived_resumes_m"]').prop("checked", true);
        }

        $(document).on("click", ".searchContent", function () {
            filterContent(ITEMS_PER_PAGE, '1', '1', '0');
        });

        $(document).on("change", ".searchKeyInput", function () {
            filterContent(ITEMS_PER_PAGE, '1', '1', '0');
        });

        $(document).on("click", ".searchContent_m", function () {
            filterContent_m(ITEMS_PER_PAGE, '1', '1', '0');
        });

        $(document).on("change", ".searchKeyInput_m", function () {
            filterContent_m(ITEMS_PER_PAGE, '1', '1', '0');
        });

        $(".paginationContent").hide();

        setTimeout(() => {
            if (pppagenum != null && pppagenum != "") {
                var web_ind = session_pageobj['industry'];
                var web_age = session_pageobj['resumeage'];
                var web_typ = session_pageobj['jobtype'];
                var web_src = session_pageobj['search_text'];
                var web_edu = session_pageobj['educationLevel'];
                var pageoffset = session_pageobj['pagination_val'];

                if (web_ind != "" || web_age != '' || web_typ != '' || web_src != '' || web_edu != '' || pageoffset != '') {
                    setTimeout(() => {
                        filterContent(ITEMS_PER_PAGE, pppagenum, '0', '0');
                    }, 500);
                } else {
                    var mob_ind = session_pageobj['industry_m'];
                    var mob_age = session_pageobj['resumeage_m'];
                    var mob_typ = session_pageobj['jobtype_m'];
                    var mob_src = session_pageobj['search_text_m'];
                    var mob_edu = session_pageobj['educationLevel_m'];
                    var pageoffset_m = session_pageobj['pagination_val_m'];

                    if (mob_ind != "" || mob_age != '' || mob_typ != '' || mob_src != '' || mob_edu != '' || pageoffset_m != '') {
                        setTimeout(() => {
                            filterContent_m(ITEMS_PER_PAGE, pppagenum, '0', '0');
                        }, 500);
                    } else {
                        filterContent(ITEMS_PER_PAGE, pppagenum, '0', '0');
                        filterContent_m(ITEMS_PER_PAGE, pppagenum, '0', '0');
                    }
                }
            } else {
                filterContent(ITEMS_PER_PAGE, '1', '0', '0');
                filterContent_m(ITEMS_PER_PAGE, '1', '0', '0');
            }
        }, 500);

    }, [isReturningFromView]);

    // --- AI SEARCH FUNCTION ---
    const runAISearch_to_delete = async (page = 1) => {
        setSearchMode("AI");
        setAiError("");


        if (!aiQuery.trim()) {
            setAiError("Please enter a profile description.");
            return;
        }

        setAiLoading(true);

        try {
            const baseurl = process.env.React_App_AWS_API;
            const res = await fetch(`${baseurl}search/resumes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Origin": window.location.origin
                },
                body: JSON.stringify({
                    query: aiQuery.trim(),
                    useAgent: true,
                    page: page,
                    pageSize: ITEMS_PER_PAGE,
                    includeDebug: true, // Needs to be true to retrieve Explanation text
                    includeExplanation: true
                })
            });

            if (!res.ok) {
                throw new Error("Server returned status " + res.status);
            }

            const data = await res.json();

            setAiResults(data && data.results ? data.results : []);
            setAiTotalItems(data && data.totalCount !== undefined ? data.totalCount : (data && data.results ? data.results.length : 0));
            setAiCurrentPage(page);
            setAiDebugData(data && data.debug ? data.debug : null);

        } catch (err) {
            console.error("AI search failed:", err);
            setAiResults([]);
            setAiTotalItems(0);
            setAiError("AI search is temporarily unavailable. Please try again later.");
        } finally {
            setAiLoading(false);
        }
    };


    const runAISearch_to_delte_feb_25_2026 = async (page = 1, isMobile = false) => {
        setSearchMode("AI");
        setAiError("");

        const queryToFetch = isMobile ? aiQuery_m.trim() : aiQuery.trim();

        if (!queryToFetch) {
            setAiError("Please enter a profile description.");
            return;
        }

        setAiLoading(true);

        try {
            const baseurl = process.env.React_App_AWS_API;
            const res = await fetch(`${baseurl}search/resumes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    query: queryToFetch,
                    useAgent: true,
                    page: page,
                    pageSize: ITEMS_PER_PAGE,
                    includeDebug: true,
                    includeExplanation: true
                })
            });

            if (!res.ok) throw new Error("Server returned status " + res.status);

            const data = await res.json();

            const fetchedResults = data && data.results ? data.results : [];
            const fetchedTotalItems = data && data.totalCount !== undefined ? data.totalCount : 0;
            const fetchedDebugData = data && data.debug ? data.debug : null;

            setAiResults(fetchedResults);
            setAiTotalItems(fetchedTotalItems);
            setAiCurrentPage(page);
            setAiDebugData(fetchedDebugData);

            // --- SAVE EVERYTHING TO SESSION STORAGE ---
            const stateToSave = {
                searchMode: "AI",
                aiQuery: queryToFetch,
                aiQuery_m: queryToFetch,
                aiResults: fetchedResults,
                aiCurrentPage: page,
                aiTotalItems: fetchedTotalItems,
                aiDebugData: fetchedDebugData
            };
            sessionStorage.setItem('ai_profile_search_state', JSON.stringify(stateToSave));

        } catch (err) {
            console.error("AI search failed:", err);
            setAiResults([]);
            setAiTotalItems(0);
            setAiError("AI search is temporarily unavailable. Please try again later.");
        } finally {
            setAiLoading(false);
        }
    };


    const runAISearch = async (page, isMobile) => {
        page = page || 1;
        isMobile = isMobile || false;
        setSearchMode("AI");
        setAiError("");
        setAiIsSearched(true);

        const queryToFetch = isMobile ? aiQuery_m.trim() : aiQuery.trim();

        if (!queryToFetch) {
            setAiError("Please enter a profile description.");
            setAiIsSearched(false);
            return;
        }

        setAiLoading(true);

        try {
            const baseurl = process.env.React_App_AWS_API;

            // 1. Fetch from AI Endpoint
            const aiRes = await fetch(baseurl + "search/resumes", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    query: queryToFetch,
                    useAgent: true,
                    page: page,
                    pageSize: ITEMS_PER_PAGE,
                    includeDebug: true,
                    includeExplanation: true
                })
            });

            if (!aiRes.ok) throw new Error("Server returned status " + aiRes.status);

            const data = await aiRes.json();

            // Legacy safe null checks
            const fetchedResultsRaw = (data && data.results) ? data.results : [];
            const fetchedTotalItems = (data && data.totalCount !== undefined) ? data.totalCount : fetchedResultsRaw.length;
            const fetchedDebugData = (data && data.debug) ? data.debug : null;

             // --- GA4 TRACKING ADDED ---
            trackGaEventV2('ai_resume_search', {
                search_term: queryToFetch,
                results_count: fetchedTotalItems
            });


            // --- GA4 TRACKING ADDED ---
            trackGaEvent('search_performed', {
                search_type: 'ai_powered',
                search_term: queryToFetch,
                results_count: fetchedTotalItems
            });

            // Extract Auth token for the hydration call
            var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");

            // 2. HYDRATE DATA: Fetch full details for each AI profile ID
            const hydratedResults = await Promise.all(
                fetchedResultsRaw.map(async (aiProfile) => {
                    try {
                        const profileId = aiProfile.candidateId ? aiProfile.candidateId.replace(/\D/g, '') : (aiProfile.id ? aiProfile.id.replace(/\D/g, '') : '');

                        if (!profileId) return aiProfile;

                        // Fetch full profile details
                        const profileRes = await fetch(baseurl + "getProfile?profileId=" + profileId, {
                            method: "GET",
                            headers: {
                                'Accept': 'application/json, text/plain, */*',
                                'Authorization': "Bearer " + accessTokenIn
                            }
                        });

                        if (!profileRes.ok) return aiProfile;

                        const profileData = await profileRes.json();

                        // 3. Merge full profile data with AI data
                        return {
                            ...aiProfile,
                            firstName: profileData.firstName || "",
                            lastName: profileData.lastName || "",
                            title: profileData.strJobType || profileData.jobTypeName || aiProfile.title,
                            jobtypename_new: profileData.strJobType || profileData.jobTypeName || aiProfile.title,
                            personalProfile: profileData.personalProfile || aiProfile.text, // The rich HTML
                            categoriesOfExpertiseName: profileData.categoriesOfExpertiseName || [],
                            levelOfEductionName: profileData.levelOfEductionName || "",
                            //updatedDate: profileData.updatedDate || null,
                            updatedDate: profileData.updateTime || null,
                            profilePicS3URL: profileData.profilePicS3URL || null,
                            city: profileData.city || aiProfile.location_city || "",
                            state: profileData.state || aiProfile.location_state || "",
                            email: profileData.email || "",
                            phone: profileData.phone || profileData.phoneno || ""
                        };
                    } catch (err) {
                        console.error("Hydration failed for profileId " + aiProfile.id, err);
                        return aiProfile;
                    }
                })
            );

            // 4. Update State
            setAiResults(hydratedResults);
            setAiTotalItems(fetchedTotalItems);
            setAiCurrentPage(page);
            setAiDebugData(fetchedDebugData);

            // --- SAVE EVERYTHING TO SESSION STORAGE ---
            const stateToSave = {
                searchMode: "AI",
                aiQuery: queryToFetch,
                aiQuery_m: queryToFetch,
                aiResults: hydratedResults,
                aiCurrentPage: page,
                aiTotalItems: fetchedTotalItems,
                aiDebugData: fetchedDebugData
            };
            sessionStorage.setItem('ai_profile_search_state', JSON.stringify(stateToSave));

        } catch (err) {
            console.error("AI search failed:", err);
            setAiResults([]);
            setAiTotalItems(0);
            setAiError("AI search is temporarily unavailable. Please try again later.");
        } finally {
            setAiLoading(false);
        }
    };

    const handleAiPageChange = (offset) => {
        runAISearch(offset);
        window.scrollTo({ top: 150, behavior: 'smooth' });
    };

    // const handleProfileClick = (profileId, rawData) => {
    //     if (rawData && searchMode === "AI") {
    //         const completeAiData = {
    //             ...rawData,
    //             debug: aiDebugData
    //         };
    //         localStorage.setItem(`ai_profile_${profileId}`, JSON.stringify(completeAiData));
    //     }
    // };

    /*
    const handleProfileClick = (profileId, rawData) => {
        
        
        var profileTitle = 'Unknown';
        if (rawData) {
            if (rawData.name) {
                profileTitle = rawData.name;
            } else if (rawData.firstName || rawData.lastName) {
                profileTitle = (rawData.firstName || '') + " " + (rawData.lastName || '');
            } else if (rawData.title) {
                profileTitle = rawData.title;
            }
        }
        
        trackGaEvent('view_item_details', {
            search_type: searchMode === "AI" ? "ai_powered" : "classic",
            clicked_item_title: profileTitle.trim(),
            search_term: searchMode === "AI" ? aiQuery.trim() : (classicSearchVal ? classicSearchVal.trim() : "no_text")
        });

        if (rawData && searchMode === "AI") {
            const completeAiData = {
                search_text_query: aiQuery,
                ...rawData,
                debug: aiDebugData
            };
            localStorage.setItem(`ai_profile_${profileId}`, JSON.stringify(completeAiData));
        }
    };
    */

    const handleProfileClick = (profileId, rawData) => {
        // ADD THIS LINE: Grab the current text in the classic search box
        var classicSearchVal = $('.searchKeyInput').val(); 
        
        var profileTitle = 'Unknown';
        if (rawData) {
            if (rawData.name) {
                profileTitle = rawData.name;
            } else if (rawData.firstName || rawData.lastName) {
                profileTitle = (rawData.firstName || '') + " " + (rawData.lastName || '');
            } else if (rawData.title) {
                profileTitle = rawData.title;
            }
        }


        var matchScore = rawData && rawData.score_percent ? Math.round(rawData.score_percent) : 'N/A';

        // --- 2. DISTINCT GA4 EVENTS: RESUME CLICKS ---
        if (searchMode === "AI") {
            trackGaEventV2('ai_resume_click', {
                clicked_item_title: profileTitle.trim(),
                search_term: aiQuery.trim(),
                match_percent: matchScore
            });
        } else {
            trackGaEventV2('classic_resume_click', {
                clicked_item_title: profileTitle.trim(),
                search_term: classicSearchVal ? classicSearchVal.trim() : "no_text"
            });
        }
        
        trackGaEvent('view_item_details', {
            search_type: searchMode === "AI" ? "ai_powered" : "classic",
            clicked_item_title: profileTitle.trim(),
            search_term: searchMode === "AI" ? aiQuery.trim() : (classicSearchVal ? classicSearchVal.trim() : "no_text")
        });

        if (rawData && searchMode === "AI") {
            const completeAiData = {
                search_text_query: aiQuery,
                ...rawData,
                debug: aiDebugData
            };
            localStorage.setItem(`ai_profile_${profileId}`, JSON.stringify(completeAiData));
        }
    };

    // --- NEW: Map Data to UI Card Component ---
    const mapProfileToCardModel_to_delete_feb_25_2026 = (profile, currentPage, mode = "CLASSIC") => {
        // 1. Define URL based on mode
        const baseUrl = mode === "AI" ? "/personalProfileViewAI" : "/personalProfileView";

        // Use candidateId for AI, profileId for Classic
        const id = mode === "AI" ? (profile.candidateId || profile.id) : profile.profileId;

        let firstName = "";
        let lastName = "";

        if (mode === "AI") {
            const nameParts = profile.name ? profile.name.split(" ") : ["", ""];
            firstName = nameParts[0] || "";
            lastName = nameParts.slice(1).join(" ") || "";
        } else {
            firstName = profile.firstName || "";
            lastName = profile.lastName || "";
        }

        return {
            id: id,
            firstName: firstName,
            lastName: lastName,
            fullName: `${firstName} ${lastName}`.trim(),
            jobTitle: mode === "AI" ? profile.title : (profile.jobtypename_new === 'Internship/Coop' ? 'College Intern/Student' : profile.jobtypename_new),
            updatedDate: mode === "CLASSIC" && profile.updatedDate ? moment(profile.updatedDate).utcOffset('-0400').format("MM/DD/YYYY") : "",
            email: mode === "CLASSIC" ? profile.email : "",
            phone: mode === "CLASSIC" ? profile.phoneno : "",
            category: mode === "CLASSIC" ? strCatArr(profile.categoryName) : "",
            profilePic: mode === "CLASSIC" && profile.profilePicS3URL ? profile.profilePicS3URL : "images/user-default.jpg",

            // 2. Map Dynamic URL
            profileUrl: `${baseUrl}?profileId=${id}&pppage=${currentPage}`,

            matchPercent: mode === "AI" && profile.score_percent ? Math.round(profile.score_percent) : null,
            location: mode === "AI" ? profile.location : "",
            skills: mode === "AI" && profile.skills ? profile.skills.slice(0, 5) : [],
            yearsOfExperience: mode === "AI" ? profile.yearsOfExperience : null,
            rawProfileData: profile
        };
    };


    const mapProfileToCardModel = (profile, currentPage, mode) => {
        mode = mode || "CLASSIC";
        const baseUrl = mode === "AI" ? "/personalProfileViewAI" : "/personalProfileView";

        // Extract numeric ID (AI sometimes returns prefixed IDs)
        const id = mode === "AI"
            ? (profile.candidateId ? profile.candidateId.replace(/\D/g, '') : (profile.id ? profile.id.replace(/\D/g, '') : ''))
            : profile.profileId;

        let firstName = profile.firstName || "";
        let lastName = profile.lastName || "";

        // Fallback for AI if names aren't split but a full 'name' is provided
        if (mode === "AI" && !firstName && !lastName && profile.name) {
            const nameParts = profile.name.split(" ");
            firstName = nameParts[0] || "";
            lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";
        }

        const rawJobType = profile.jobtypename_new || profile.strJobType || profile.jobTypeName || profile.title || "Professional";
        const jobTitle = rawJobType === 'Internship/Coop' ? 'College Intern/Student' : rawJobType;

        // Use rich HTML summary if available, otherwise fallback to AI text, and strip HTML for the preview
        const rawSummary = profile.profileSummary || profile.personalProfile || profile.text || "";
        const cleanSummary = rawSummary.replace(/<[^>]+>/g, '');

        // Location string formatting
        const locationArr = [];
        if (profile.city) locationArr.push(profile.city);
        if (profile.state) locationArr.push(profile.state);
        const locationStr = locationArr.join(", ");
        const finalLocation = locationStr ? locationStr : (profile.location || "");

        return {
            id: id,
            firstName: firstName,
            lastName: lastName,
            fullName: (firstName + " " + lastName).trim() || "Unknown Candidate",
            jobTitle: jobTitle,
            updatedDate: profile.updatedDate ? moment(profile.updatedDate).utcOffset('-0400').format("MM/DD/YYYY") : "",
            email: profile.email || "",
            phone: profile.phoneno || profile.phone || "",
            category: strCatArr(profile.categoryName || profile.categoriesOfExpertiseName),
            profilePic: profile.profilePicS3URL ? profile.profilePicS3URL : "images/user-default.jpg",

            profileUrl: baseUrl + "?profileId=" + id + "&pppage=" + currentPage,

            matchPercent: mode === "AI" && profile.score_percent ? Math.round(profile.score_percent) : null,
            location: finalLocation,
            skills: mode === "AI" && profile.skills && Array.isArray(profile.skills) ? profile.skills.slice(0, 8) : [],
            yearsOfExperience: profile.yearsOfExperience || null,
            employmentType: profile.employmentType || null,
            educationLevel: profile.levelOfEductionName || "",

            summarySnippet: cleanSummary.length > 220 ? cleanSummary.substring(0, 220) + "..." : cleanSummary,
            categoryNameArr: profile.categoryName || profile.categoriesOfExpertiseName || [],

            rawProfileData: profile
        };
    };

    const displayProfiles = useMemo(() => {
        if (searchMode === "AI") {
            return aiResults.map((p) => mapProfileToCardModel(p, aiCurrentPage, "AI"));
        }
        return profileList.map((p) => mapProfileToCardModel(p, currentPage, "CLASSIC"));
    }, [searchMode, aiResults, profileList, currentPage, aiCurrentPage]);

    const displayProfiles_m = useMemo(() => {
        if (searchMode === "AI") {
            return aiResults.map((p) => mapProfileToCardModel(p, aiCurrentPage, "AI"));
        }
        return profileList_m.map((p) => mapProfileToCardModel(p, currentPage_m, "CLASSIC"));
    }, [searchMode, aiResults, profileList_m, currentPage_m, aiCurrentPage]);

    // --- UTILITY/SERVICE FUNCTIONS ---
    function getServiceProfileInfo() {
        Services.getCompanyProfile(companyId).then((res) => {
            setCategoriesSelected(res.data.companyCategory);
            var serviceresponse = res.data.companyCategory;
            var storeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('company_profile', storeval);
            localStorage.setItem('company_profile', storeval);
        });
    }

    function getLocalProfileInfo() {
        var localindustryval = sessionStorage.getItem('company_profile') || localStorage.getItem("company_profile");
        localindustryval = JSON.parse(localindustryval);
        setCategoriesSelected(localindustryval);
    }

    const handlePageChange2 = (offset, triggerevent) => {
        filterContent(ITEMS_PER_PAGE, offset, '0', '1');
    };

    const handlePageChange2_m = (offset, triggerevent) => {
        filterContent_m(ITEMS_PER_PAGE, offset, '0', '1');
    };

    // ReactSelect Change Handlers
    const handleChangeForCate_d = (selected) => setoptionCatSelectedd(selected || []);
    const handleChangeForCate_m = (selected) => setoptionCatSelectedm(selected || []);

    const handleChange_d = (selected) => setoptionSelectedd(selected || []);
    const handleChange_m = (selected) => setoptionSelectedm(selected || []);

    const handleChangeForEdu_d = (selected) => setoptionEduSelectedd(selected || []);
    const handleChangeForEdu_m = (selected) => setoptionEduSelectedm(selected || []);


    const filterContent = (ITEMS_PER_PAGE, pageNumber, setlcstorage, positiontop) => {
        var categoriesArray = optionCatSelected_d.map(val => val.value.toString());
        var jobTypeArray = optionSelected_d.map(val => val.value.toString());
        var educationId = optionEduSelected_d.length > 0 ? optionEduSelected_d.map(val => val.value.toString()).join(',') : '';

        var showarchived = 0;
        if ($("input[name='archived_resumes']").prop('checked')) {
            showarchived = 1;
        }

        var searchkey = $('.searchKeyInput').val();

        var industries_val2 = '';
        var jobtype_val2 = '';
        var education_val2 = '';

        if (setlcstorage == "1") {
            if (categoriesArray.length > 0) industries_val2 = categoriesArray;
            if (jobTypeArray.length > 0) jobtype_val2 = jobTypeArray;
            if (educationId != '') education_val2 = educationId;
        }

        var jsonData = {
            "personal_Profiles": {
                "industry": categoriesArray,
                "resumeage": showarchived,
                "jobtype": jobTypeArray,
                "search_text": searchkey,
                "pagination_val": pageNumber > 1 ? pageNumber : '',
                "educationLevel": educationId,
                "industry_m": '',
                "resumeage_m": '',
                "jobtype_m": '',
                "search_text_m": "",
                "pagination_val_m": '',
                "educationLevel_m": ''
            }
        };

        var jsondataformatted = JSON.stringify(jsonData);
        sessionStorage.setItem('pagejsonObject', jsondataformatted);

        var serachkeyinput = $(".searchKeyInput").val();
        if (serachkeyinput != undefined) {
            serachkeyinput = serachkeyinput.trim();
        }
        const requestObject = {
            "siteId": process.env.React_App_SITE_ID,
            "categoriesOfExpertise": categoriesArray,
            "type": jobTypeArray,
            "eduExpInfo": serachkeyinput,
            "titleSummary": serachkeyinput,
            "pageNumber": pageNumber,
            "educationId": educationId,
            "archivedResumes": showarchived,
            "pageSize": ITEMS_PER_PAGE,
            "sortBy": "updatedOn"
        }

        var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + accessTokenIn
            },
            body: JSON.stringify(requestObject)
        };

        Services.findFilterProfile(requestOptions).then((res) => {
            setIsSearched(true);
            if (res.content) {
                $(".paginationContent").show();
                if (positiontop == 1) {
                    window.scrollTo({ top: 100, behavior: 'smooth' });
                }
                setTotalItems(res.totalElements);
                settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage(pageNumber);

                // --- GA4 TRACKING ADDED ---
                if (setlcstorage === "1") {


                    // Bundle all active dropdown filters to send to GA4
                    let activeFilters = [];
                    if (optionCatSelected_d && optionCatSelected_d.length) activeFilters.push("Ind: " + optionCatSelected_d.map(x=>x.label).join("|"));
                    if (optionSelected_d && optionSelected_d.length) activeFilters.push("Type: " + optionSelected_d.map(x=>x.label).join("|"));
                    if (optionEduSelected_d && optionEduSelected_d.length) activeFilters.push("Edu: " + optionEduSelected_d.map(x=>x.label).join("|"));

                    let finalSearchTerm = serachkeyinput;
                    if (activeFilters.length > 0) {
                        finalSearchTerm = serachkeyinput ? serachkeyinput + " [" + activeFilters.join(", ") + "]" : "[" + activeFilters.join(", ") + "]";
                    } else if (!serachkeyinput) {
                        finalSearchTerm = "no_filters_applied";
                    }

                    trackGaEventV2('classic_resume_search', {
                        search_term: finalSearchTerm,
                        results_count: res.totalElements || 0
                    });


                    trackGaEvent('search_performed', {
                        search_type: 'classic',
                        search_term: serachkeyinput || "no_text_filters_only",
                        results_count: res.totalElements || 0
                    });
                }

                var contAr = res.content;
                for (var i = 0; i < contAr.length; i++) {
                    var jobtypename = contAr[i].strJobType;
                    var typename = jobtypename.split("(");
                    contAr[i].jobtypename_new = typename[0];
                }
                setProfileList(contAr);
                if (contAr.length > 0) {
                    $(".paginationContent").show();
                } else {
                    $(".paginationContent").hide();
                }
            }
        });
        $(".doublecards").hide();
    }

    const filterContent_m = (ITEMS_PER_PAGE, pageNumber, setlcstorage, positiontop) => {
        var categoriesArray = optionCatSelected_m.map(val => val.value.toString());
        var jobTypeArray = optionSelected_m.map(val => val.value.toString());
        var educationId = optionEduSelected_m.length > 0 ? optionEduSelected_m.map(val => val.value.toString()).join(',') : '';

        var showarchived = 0;
        if ($("input[name='archived_resumes_m']").prop('checked')) {
            showarchived = 1;
        }

        var searchkey = $('.searchKeyInput_m').val();

        var industries_val2_m = categoriesArray.length > 0 ? categoriesArray : '';
        var jobtype_val2_m = jobTypeArray.length > 0 ? jobTypeArray : '';
        var education_val2_m = educationId != '' ? educationId : '';

        var jsonData = {
            "personal_Profiles": {
                "industry": '',
                "resumeage": '',
                "jobtype": '',
                "search_text": '',
                "pagination_val": '',
                "educationLevel": '',
                "industry_m": industries_val2_m,
                "resumeage_m": showarchived,
                "jobtype_m": jobtype_val2_m,
                "search_text_m": searchkey,
                "pagination_val_m": pageNumber > 1 ? pageNumber : '',
                "educationLevel_m": education_val2_m
            }
        };

        var jsondataformatted = JSON.stringify(jsonData);
        sessionStorage.setItem('pagejsonObject', jsondataformatted);
        localStorage.setItem('pagejsonObject', jsondataformatted);

        var searchkeyinput_m = $(".searchKeyInput_m").val();
        if (searchkeyinput_m != undefined) {
            searchkeyinput_m = searchkeyinput_m.trim();
        }

        const requestObject = {
            "siteId": process.env.React_App_SITE_ID,
            "categoriesOfExpertise": categoriesArray,
            "type": jobTypeArray,
            "eduExpInfo": searchkeyinput_m,
            "titleSummary": searchkeyinput_m,
            "pageNumber": pageNumber,
            "archivedResumes": showarchived,
            "pageSize": ITEMS_PER_PAGE,
            "sortBy": "updatedOn",
            "educationId": educationId,
        }
        var accessTokenIn = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + accessTokenIn
            },
            body: JSON.stringify(requestObject)
        };

        Services.findFilterProfile(requestOptions).then((res) => {
            if (res.content) {
                $(".paginationContent").show();
                if (positiontop == 1) {
                    window.scrollTo({ top: 100, behavior: 'smooth' });
                }
                setTotalItems_m(res.totalElements);
                settotalPages_m(Math.ceil(res.totalElements / ITEMS_PER_PAGE));
                setCurrentPage_m(pageNumber);

                var contAr = res.content;
                for (var i = 0; i < contAr.length; i++) {
                    var jobtypename = contAr[i].strJobType;
                    var typename = jobtypename.split("(");
                    contAr[i].jobtypename_new = typename[0];
                }
                setProfileList_m(contAr);
                if (contAr.length > 0) {
                    $(".paginationContent").show();
                } else {
                    $(".paginationContent").hide();
                }
            }
        });

        $(".doublecards").hide();
    }

    const ClearAll = () => {
        setoptionCatSelectedd([]);
        setoptionCatSelectedm([]);
        setoptionSelectedd([]);
        setoptionSelectedm([]);
        setoptionEduSelectedd([]);
        setoptionEduSelectedm([]);
        $('.searchKeyInput').val('');
        $('.searchKeyInput_m').val('');
        $('input[name="archived_resumes"]').prop("checked", false);
        $('input[name="archived_resumes_m"]').prop("checked", false);

        filterContent(ITEMS_PER_PAGE, '1', '1', '0');
        filterContent_m(ITEMS_PER_PAGE, '1', '1', '0');
    }

    const getServiceIndustryData = () => {
        Services.getIndustryData().then((res) => {
            setCategory(res.data.content);
            var serviceresponse = res.data.content;
            var dummArray = res.data.content.map(c => ({ value: c.catId, label: c.name }));
            setMulCategory_d(dummArray);

            var storeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_industry', storeval);
            localStorage.setItem('master_industry', storeval);

            setTimeout(() => {
                var loc_ind = session_pageobj['industry'];
                if (loc_ind) {
                    var arr = Array.isArray(loc_ind) ? loc_ind : loc_ind.toString().split(",");
                    setoptionCatSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_ind_m = session_pageobj['industry_m'];
                if (loc_ind_m) {
                    var arr_m = Array.isArray(loc_ind_m) ? loc_ind_m : loc_ind_m.toString().split(",");
                    setoptionCatSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        });
    }

    const getLocalIndustryData = () => {
        var localindustryval = sessionStorage.getItem('master_industry') || localStorage.getItem("master_industry");
        if (localindustryval) {
            var parsed = JSON.parse(localindustryval);
            setCategory(parsed);
            var dummArray = parsed.map(c => ({ value: c.catId, label: c.name }));
            setMulCategory_d(dummArray);

            setTimeout(() => {
                var loc_ind = session_pageobj['industry'];
                if (loc_ind) {
                    var arr = Array.isArray(loc_ind) ? loc_ind : loc_ind.toString().split(",");
                    setoptionCatSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_ind_m = session_pageobj['industry_m'];
                if (loc_ind_m) {
                    var arr_m = Array.isArray(loc_ind_m) ? loc_ind_m : loc_ind_m.toString().split(",");
                    setoptionCatSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        }
    }

    const getServiceJobType = () => {
        Services.getJobType().then((res) => {
            var tempjobtypes = res.data.content;
            var serviceresponse = res.data.content;
            const index = tempjobtypes.findIndex((el) => el.name === "Internship/Coop")
            try {
                var jtid = tempjobtypes[index].jobTypeId;
                tempjobtypes[index] = { name: 'College Intern/Student', jobTypeId: jtid }
            } catch (ex) { }

            var jobtypes_sorted = tempjobtypes.filter(elem => elem.name !== 'Job Shadow' && elem.name !== 'Continuing Education');
            jobtypes_sorted = jobtypes_sorted.sort((a, b) => b.jobTypeId - a.jobTypeId);
            array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));

            var dummArray = jobtypes_sorted.map(j => ({ value: j.jobTypeId, label: j.name.split("(")[0] }));
            setJobType(dummArray);
            setMulJobTypes(dummArray);

            var storetypeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_jobtype', storetypeval);
            localStorage.setItem('master_jobtype', storetypeval);

            setTimeout(() => {
                var loc_job = session_pageobj['jobtype'];
                if (loc_job) {
                    var arr = Array.isArray(loc_job) ? loc_job : loc_job.toString().split(",");
                    setoptionSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_job_m = session_pageobj['jobtype_m'];
                if (loc_job_m) {
                    var arr_m = Array.isArray(loc_job_m) ? loc_job_m : loc_job_m.toString().split(",");
                    setoptionSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        });
    }

    const getLocalJobType = () => {
        var localjobtypeval = sessionStorage.getItem('master_jobtype') || localStorage.getItem("master_jobtype");
        if (localjobtypeval) {
            var tempjobtypes = JSON.parse(localjobtypeval);
            const index = tempjobtypes.findIndex((el) => el.name === "Internship/Coop")
            try {
                var jtid = tempjobtypes[index].jobTypeId;
                tempjobtypes[index] = { name: 'College Intern/Student', jobTypeId: jtid }
            } catch (ex) { }

            var jobtypes_sorted = tempjobtypes.filter(elem => elem.name !== 'Job Shadow' && elem.name !== 'Continuing Education');
            jobtypes_sorted = jobtypes_sorted.sort((a, b) => b.jobTypeId - a.jobTypeId);
            array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));

            var dummArray = jobtypes_sorted.map(j => ({ value: j.jobTypeId, label: j.name.split("(")[0] }));
            setJobType(dummArray);
            setMulJobTypes(dummArray);

            setTimeout(() => {
                var loc_job = session_pageobj['jobtype'];
                if (loc_job) {
                    var arr = Array.isArray(loc_job) ? loc_job : loc_job.toString().split(",");
                    setoptionSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_job_m = session_pageobj['jobtype_m'];
                if (loc_job_m) {
                    var arr_m = Array.isArray(loc_job_m) ? loc_job_m : loc_job_m.toString().split(",");
                    setoptionSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        }
    }

    const getServiceEdicationInfo = () => {
        Services.getEducation().then((res) => {
            setEducations(res.data.content);
            var serviceresponse = res.data.content;
            var dummArray = res.data.content.map(e => ({ value: e.educationId, label: e.name }));
            setMulEducationTypes(dummArray);

            var storeval = JSON.stringify(serviceresponse);
            sessionStorage.setItem('master_educationsprof', storeval);
            localStorage.setItem('master_educationsprof', storeval);

            setTimeout(() => {
                var loc_edu = session_pageobj['educationLevel'];
                if (loc_edu) {
                    var arr = Array.isArray(loc_edu) ? loc_edu : loc_edu.toString().split(",");
                    setoptionEduSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_edu_m = session_pageobj['educationLevel_m'];
                if (loc_edu_m) {
                    var arr_m = Array.isArray(loc_edu_m) ? loc_edu_m : loc_edu_m.toString().split(",");
                    setoptionEduSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        });
    }

    const getLocalEdicationInfo = () => {
        var localeducationval = sessionStorage.getItem('master_educationsprof') || localStorage.getItem("master_educationsprof");
        if (localeducationval) {
            var tempeducaions = JSON.parse(localeducationval);
            setEducations(tempeducaions);
            var dummArray = tempeducaions.map(e => ({ value: e.educationId, label: e.name }));
            setMulEducationTypes(dummArray);

            setTimeout(() => {
                var loc_edu = session_pageobj['educationLevel'];
                if (loc_edu) {
                    var arr = Array.isArray(loc_edu) ? loc_edu : loc_edu.toString().split(",");
                    setoptionEduSelectedd(dummArray.filter(c => arr.includes(c.value.toString())));
                }
                var loc_edu_m = session_pageobj['educationLevel_m'];
                if (loc_edu_m) {
                    var arr_m = Array.isArray(loc_edu_m) ? loc_edu_m : loc_edu_m.toString().split(",");
                    setoptionEduSelectedm(dummArray.filter(c => arr_m.includes(c.value.toString())));
                }
            }, 500);
        }
    }

    function array_move(arr, old_index, new_index) {
        if (new_index >= arr.length) {
            var k = new_index - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
        return arr;
    };

    const { register, formState: { errors }, handleSubmit } = useForm({ criteriaMode: "all", mode: "onBlur" });

    return (
        <>
            <main className="empr-directory-main">
                <div className="main-bgpatten"></div>

                {/* Breadcrumb Section */}
                <section className="headtitle-wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <nav style={{ "--bs-breadcrumb-divider": "'>';" }} aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item headtitle"><Link to={"/companyJobs"}>Company Dashboard</Link> </li>
                                        <li className="breadcrumb-item headtitle"><Link to={""}>Personal Profiles</Link></li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="py-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 ">
                                <div className="white-bg p-5 ">
                                    <div className="row">
                                        <div className="input-ai-container px-0">
                                            <div className="container mb-4 px-0">

                                                {/* Tabs */}
                                                <div className="align-items-center ai-flex">
                                                    <h4 className="mb-0 mr-2">SEARCH MODE:</h4>
                                                    <ul className="nav nav-tabs" id="jobTabs" role="tablist">
                                                        <li className="nav-item ai-nav">
                                                            <button
                                                                className={`nav-link ${searchMode === "CLASSIC" ? "active" : ""}`}
                                                                id="search-tab"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#search"
                                                                type="button"
                                                                onClick={() => {
                                                                    setSearchMode("CLASSIC");
                                                                    handleTabChange("CLASSIC");
                                                                }}
                                                            >
                                                                Classic Search
                                                            </button>
                                                        </li>

                                                        <li className="nav-item ai-nav">
                                                            <button
                                                                className={`nav-link ${searchMode === "AI" ? "active" : ""}`}
                                                                id="ai-search-tab"
                                                                data-bs-toggle="tab"
                                                                data-bs-target="#aisearch"
                                                                type="button"


                                                                onClick={() => {
                                                                    setSearchMode("AI");
                                                                    handleTabChange("AI");
                                                                }}
                                                            >
                                                                AI-Powered Search <label htmlFor="" className="new">New</label>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>

                                                {/* Tab Content */}
                                                <div className="tab-content p-4">

                                                    {/* AI Job Search */}
                                                    {searchMode === "AI" && (
                                                        <div className="tab-pane fade show active" id="aisearch">
                                                            <div className="position-relaive">
                                                                <textarea
                                                                    className="ai-form-control"
                                                                    placeholder="Describe the ideal profile (e.g., Experienced CNC Mill Supervisor with 9+ years in programming...)"
                                                                    value={aiQuery}
                                                                    onChange={(e) => setAiQuery(e.target.value)}
                                                                ></textarea>
                                                                <button
                                                                    className="btn btn-primary ai-search-button"
                                                                    onClick={() => runAISearch(1)}
                                                                    disabled={aiLoading}
                                                                >
                                                                       <img src="/images/roboto.png" alt="AI" className="me-2" />
                                                                    {aiLoading ? "Searching..." : "AI Search"}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Classic Search */}
                                                    {searchMode === "CLASSIC" && (
                                                        <div className="tab-pane fade show active" id="search" role="tabpanel">
                                                            <div className="filter-wrapper">
                                                                <div className="filter-card">
                                                                    {/* Keywords */}
                                                                    <div className="filter-group full-width">
                                                                        <label className="label">KEYWORDS</label>
                                                                        <input
                                                                            type="text"
                                                                            id="search_text"
                                                                            className="input searchKeyInput"
                                                                            placeholder="Search by Name / Title"
                                                                        />
                                                                    </div>

                                                                    {/* Dropdown Row */}
                                                                    <div className="filter-row">
                                                                        {/* Industry */}
                                                                        <div className="filter-group custom-select-wrapper" ref={industryRef}>
                                                                            <label className="label">CATEGORIES OF INTEREST</label>
                                                                            <ReactSelect
                                                                                options={mulcategories_d}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChangeForCate_d}
                                                                                value={optionCatSelected_d}
                                                                                placeholder="Select.."
                                                                                menuIsOpen={openDropdown === 'industry_d'}
                                                                                onMenuOpen={() => setOpenDropdown('industry_d')}


                                                                            />
                                                                        </div>

                                                                        {/* Job Type */}
                                                                        <div className="filter-group custom-select-wrapper" ref={jobTypeRef}>
                                                                            <label className="label">JOB TYPE</label>
                                                                            <ReactSelect
                                                                                options={muljobTypes}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChange_d}
                                                                                value={optionSelected_d}
                                                                                placeholder="Select.."
                                                                                menuIsOpen={openDropdown === 'jobtype_d'}
                                                                                onMenuOpen={() => setOpenDropdown('jobtype_d')}
                                                                            />
                                                                        </div>

                                                                        {/* Education */}
                                                                        <div className="filter-group custom-select-wrapper" ref={educationRef}>
                                                                            <label className="label">EDUCATION</label>
                                                                            <ReactSelect
                                                                                options={muleducation}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CustomOption, ValueContainer: CustomValueContainer }}
                                                                                onChange={handleChangeForEdu_d}
                                                                                value={optionEduSelected_d}
                                                                                placeholder="Select.."
                                                                                menuIsOpen={openDropdown === 'education_d'}
                                                                                onMenuOpen={() => setOpenDropdown('education_d')}
                                                                            />
                                                                        </div>

                                                                        {/* Resume Archive Checkbox */}
                                                                        <div className="filter-group">
                                                                            <label className="label">RESUME ARCHIVE</label>
                                                                            <label style={{ display: "flex", alignItems: "center", gap: "8px", paddingTop: 10 }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="archived_resumes"
                                                                                    className="searchContent"
                                                                                />
                                                                                <small>Show Archived Resumes Only</small>
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    {/* Buttons */}
                                                                    <div className="button-row">
                                                                        <button className="reset-btn" onClick={ClearAll}>RESET</button>
                                                                        <button className="filter-btn" onClick={() => filterContent(ITEMS_PER_PAGE, '1', '1', '0')}>FILTER</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Results Block */}
                                        <div className="col-lg-12 mb-4">
                                            {/* Header logic */}
                                            {((searchMode === "CLASSIC" && profileList.length > 0) || (searchMode === "AI" && aiResults.length > 0)) && (
                                                <div className="container mb-2 px-0">
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="float-end">
                                                            {searchMode === "CLASSIC"
                                                                ? `${totalItems} Profiles - Page ${currentPage} of ${totalpages || 1}`
                                                                : `${aiTotalItems} Profiles - Page ${aiCurrentPage} of ${Math.ceil(aiTotalItems / ITEMS_PER_PAGE) || 1}`
                                                            }
                                                        </span>
                                                    </div>
                                                </div>
                                            )}

                                            {searchMode === "AI" && aiLoading && (
                                                <div className="text-center py-4 text-muted">
                                                    Searching resumes using AI…
                                                </div>
                                            )}

                                            {searchMode === "AI" && aiError && (
                                                <div className="alert alert-warning text-center">
                                                    {aiError}
                                                </div>
                                            )}

                                            {/* {searchMode === "AI" && !aiLoading && aiResults.length === 0 && !aiError && (
                                                <div className="text-center py-5 text-muted border">
                                                    No AI results found. Try refining your description.
                                                </div>
                                            )} */}

                                            {/* AI No Results Message  */}
                                            {searchMode === "AI" && aiIsSearched && !aiLoading && aiResults.length === 0 && !aiError && (
                                                <div className="text-center py-5 text-muted border">
                                                    No AI results found. Try refining your description.
                                                </div>
                                            )}

                                            <div>
                                                {/* Classic Rendering Unified */}
                                                {searchMode === "CLASSIC" && profileList.map((data, index) => {
                                                    const profileId = data.profileId || '';
                                                    const name = `${data.firstName || ''} ${data.lastName || ''}`.trim() || "Unknown Candidate";
                                                    const title = data.jobtypename_new === 'Internship/Coop' ? 'College Intern/Student' : (data.jobtypename_new || "Professional");
                                                    const locationStr = [data.city, data.state].filter(Boolean).join(", ");
                                                    const postedDate = data.updatedDate ? moment(data.updatedDate).utcOffset('-0400').format("MM/DD/YYYY") : "";
                                                    const cleanSummary = data.profileSummary ? data.profileSummary.replace(/<[^>]+>/g, '') : "";

                                                    return (
                                                        <div className="resume-card mb-2" key={`classic-d-${index}`}>
                                                            <div className="avatar-logo">
                                                                <img src={data.profilePicS3URL ? data.profilePicS3URL : "images/user-default.jpg"} style={{ width: "100%", borderRadius: "50%" }} alt="User" />
                                                            </div>
                                                            <div>
                                                                <div className="job-header">
                                                                    <div>
                                                                        <h2 className="job-title text-capitalize">
                                                                            <Link to={`/personalProfileView?profileId=${profileId}&pppage=${currentPage}`}>
                                                                                {name}
                                                                            </Link>
                                                                        </h2>
                                                                        <p className="job-meta">
                                                                            <span className="post-tile text-capitalize"> {title}</span>
                                                                        </p>

                                                                        <div className="job-meta">
                                                                            {/* {data.strJobType && (
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="me-1 sm-icon">
                                                                                        <img src="/images/vision.png" alt="Type" />
                                                                                    </span>
                                                                                    <span className="text-capitalize">{data.strJobType.split('(')[0].trim()}</span>
                                                                                </div>
                                                                            )} */}
                                                                            {data.levelOfEductionName && (
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="me-1 sm-icon">
                                                                                        <img src="/images/user.png" alt="Education" />
                                                                                    </span>
                                                                                    <span className="text-capitalize">{data.levelOfEductionName}</span>
                                                                                </div>
                                                                            )}
                                                                            {postedDate && (
                                                                                <span className="posted"> Updated: {postedDate}</span>
                                                                            )}
                                                                            {locationStr && (
                                                                                <span className="posted text-capitalize"> | {locationStr}</span>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <p className="job-description">
                                                                    {cleanSummary ? cleanSummary.substring(0, 220) + "..." : ""}
                                                                </p>

                                                                {data.categoryName && data.categoryName.length > 0 && (
                                                                    <div className="skills-section">
                                                                        <span className="mr-2">Categories:</span>
                                                                        <div className="skills">
                                                                            {data.categoryName.slice(0, 8).map((cat, cIdx) => (
                                                                                <span className="skill text-capitalize" key={cIdx}>{cat}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="d-flex justify-content-between align-items-center pt-4">
                                                                    <div className="ms-auto">
                                                                        <Link to={`/personalProfileView?profileId=${profileId}&pppage=${currentPage}`} onClick={() => handleProfileClick(profileId, data)} className="reg-button d-block">
                                                                            VIEW FULL DETAILS
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                                {/* AI Rendering Unified */}
                                                {searchMode === "AI" && !aiLoading && aiResults.map((profile, index) => {
                                                    const profileId = profile.candidateId ? profile.candidateId.replace(/\D/g, '') : (profile.id ? profile.id.replace(/\D/g, '') : '');
                                                    const postedDate = profile.updatedDate ? moment(profile.updatedDate).utcOffset('-0400').format("MM/DD/YYYY") : "";
                                                    return (
                                                        <div className="resume-card mb-2" key={`ai-${index}`}>
                                                            <div className="avatar-logo">
                                                                {/* <img src="images/user-default.jpg" style={{ width: "100%", borderRadius: "50%" }} alt="User" /> */}
                                                                <img src={profile.profilePicS3URL ? profile.profilePicS3URL : "images/user-default.jpg"} style={{ width: "100%", borderRadius: "50%" }} alt="User" />
                                                            </div>


                                                            <div>
                                                                <div className="job-header">
                                                                    <div>
                                                                        <h2 className="job-title text-capitalize">
                                                                            <Link
                                                                                to={`/personalProfileViewAI?profileId=${profileId}&pppage=${aiCurrentPage}`}
                                                                                onClick={() => handleProfileClick(profileId, profile)}
                                                                            >
                                                                                {profile.name || "Unknown Candidate"}
                                                                            </Link>


                                                                        </h2>
                                                                        <p className="job-meta">
                                                                            <span className="post-tile text-capitalize"> {profile.title || "Professional"}</span>
                                                                        </p>

                                                                        <div className="job-meta">
                                                                            {profile.employmentType && profile.employmentType !== "any" && (
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="me-1 sm-icon">
                                                                                        <img src="/images/vision.png" alt="" />
                                                                                    </span>
                                                                                    <span className="text-capitalize">{profile.employmentType}</span>
                                                                                </div>
                                                                            )}
                                                                            {profile.yearsOfExperience != null && (
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="me-1 sm-icon">
                                                                                        <img src="/images/user.png" alt="" />
                                                                                    </span>
                                                                                    <span>{profile.yearsOfExperience} Years Exp </span>
                                                                                </div>
                                                                            )}
                                                                            {profile.location && (
                                                                                <span className="posted text-capitalize"> | {profile.location}</span>
                                                                            )}
                                                                             {postedDate && (
                                                                                <span className="posted"> Updated: {postedDate}</span>
                                                                            )}

                                                                        </div>
                                                                    </div>

                                                                    {profile.score_percent !== null && profile.score_percent !== undefined && (
                                                                        <div className={profile.score_percent >= 60 ? "ai-badge" : "ai-badge-red"}>
                                                                            {Math.round(profile.score_percent)}% Match
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                <p className="job-description">
                                                                    {profile.text ? profile.text.substring(0, 220) + "..." : ""}
                                                                </p>

                                                                {profile.skills && profile.skills.length > 0 && (
                                                                    <div className="skills-section">
                                                                        <span className="mr-2 ks" >Key Skills:</span>
                                                                        <div className="skills">
                                                                            {profile.skills.slice(0, 8).map((skill, sIdx) => (
                                                                                <span className="skill text-capitalize" key={sIdx}>{skill}</span>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="d-flex justify-content-between align-items-center pt-4">
                                                                    <div className="ms-auto">
                                                                        <Link
                                                                            to={`/personalProfileViewAI?profileId=${profileId}&pppage=${aiCurrentPage}`}
                                                                            onClick={() => handleProfileClick(profileId, profile)}
                                                                            className="reg-button d-block"
                                                                        >
                                                                            VIEW FULL DETAILS
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>

                                            {/* Unified Pagination */}
                                            <div className="paginationContent mt-3">
                                                <nav aria-label="..." className="m-auto text-center">
                                                    <ul className="pagination  d-inline-flex">
                                                        {searchMode === "CLASSIC" && profileList.length > 0 && (
                                                            <Pagination
                                                                total={totalItems}
                                                                itemsPerPage={ITEMS_PER_PAGE}
                                                                currentPage={currentPage}
                                                                onPageChange={handlePageChange2}
                                                            />
                                                        )}

                                                        {searchMode === "AI" && aiResults.length > 0 && (
                                                            <Pagination
                                                                total={aiTotalItems}
                                                                itemsPerPage={ITEMS_PER_PAGE}
                                                                currentPage={aiCurrentPage}
                                                                onPageChange={handleAiPageChange}
                                                            />
                                                        )}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
};

PersonalProfilesAI.propTypes = {};

PersonalProfilesAI.defaultProps = {};

export default PersonalProfilesAI;